import React, { useContext } from "react";
import "./Twelvemm.scss";
import see from "../../assets/seein3d.svg"
import threed from "../../assets/3dimg.jpg"
import { SquareContext } from "../../SquareContext";

function Twelvemm(props) {
  const {
  
    resultTotal,
    edgeName,
    stater,
    cuts,
    cuts2,
    grooves,
    overSink,
    underSink,
    pop,
    tap,
    hob,
    splash,
    upst,
    led,
    jum,
    resSum,
    recessed,
    countyId,
    thousands_separators, summary,
    sideName
  } = useContext(SquareContext);


  
  
  const addVAT12 = Math.round((props.subCost12 * 0.2) * 100) / 100
  
  const withVAT12 = addVAT12 + (Math.round(props.subCost12 * 100) / 100)




  return (
    <>
      <div className="twelvemm">
        <div className="one1">
          <p className="atr">Your Chosen color:</p>
          <div className="atr2">{props.unit}</div>
        </div>
        <div className="one2">
          <p className="atr">Total Area:</p>
          <div className="atr2">
            <p>{resultTotal}</p>
            <p>m squared</p>
          </div>
        </div>
        <div className="one3">
          <p className="atr">Total length of polished edge:</p>
          <div className="atr2">
            <p>{resSum}</p>
            <p>m</p>
          </div>
        </div>
        <div className="one4">
          <p className="atr">Your Chosen edge finish:</p>
          <div className="atr2">
            {edgeName[0]}
            <p>12mm</p>
          </div>
        </div>
        <div className="one5">
          <p className="atr">Number of rounded corners:</p>
          <div className="atr2">
            <p>{stater}</p>
          </div>
        </div>
        <div className="one6">
          <p className="atr"> Overmounted Sink:</p>
          <div className="atr2">
            <p>{overSink}</p>
          </div>
        </div>
        <div className="one7">
          <p className="atr">Undermounted Sink:</p>
          <div className="atr2">
            <p>{underSink}</p>
          </div>
        </div>
        <div className="one8">
          <p className="atr">Draining Grooves:</p>
          <div className="atr2">
            <p>{grooves}</p>
          </div>
        </div>
        <div className="one9">
          <p className="atr">Tap Hole:</p>
          <div className="atr2">
            <p>{tap}</p>
          </div>
        </div>
        <div className="one10">
          <p className="atr">Side Panels:</p>
          <div className="atr2">
            <p>{cuts}</p>
            <p>{sideName}</p>
          </div>
        </div>
        <div className="one11">
          <p className="atr">Windowsills:</p>
          <div className="atr2">
            <p>{cuts2}</p>
          </div>
        </div>
        <div className="one12">
          <p className="atr">Hob cut-out</p>
          <div className="atr2">
            <p>{hob}</p>
          </div>
        </div>
        <div className="one13">
          <p className="atr">Pop-out socket cut-out</p>
          <div className="atr2">
            <p>{pop}</p>
          </div>
        </div>
        <div className="one14">
          <p className="atr">Splashback:</p>
          <div className="atr2">
            <p>{splash}</p>
          </div>
        </div>
        <div className="one15">
          <p className="atr">Upstands:</p>
          <div className="atr2">
            <p>{upst}</p>
          </div>
        </div>
        <div className="one16">
          <p className="atr">LED Grooves:</p>
          <div className="atr2">
            <p>{led}</p>
          </div>
        </div>
        <div className="one17">
          <p className="atr">Recessed Area:</p>
          <div className="atr2">
            <p>{recessed}</p>
          </div>
        </div>
        <div className="one18">
          <p className="atr">Area of instalation:</p>
          <div className="atr2">
            <p>{countyId.name}</p>
          </div>
        </div>
        <div className="onePrice">
          <p className="artprice">Sub Total:</p>
          <div className="art2price">
            <div>
            <p>&pound; {props.subCost12.toFixed(2)}</p>
            </div>
            <div>
            </div>
          </div>
        </div>
        <div className="onePrice2">
          <p className="artprice">VAT 20%:</p>
          <div className="art2price">
            <div>
            <p>&pound; {addVAT12.toFixed(2)}</p>
            </div>
            <div>
            </div>
          </div>
        </div>
        <hr className="ele-line5"></hr>
        <div className="total-container">
          <div className="totalEst">
            <p>Total Estimated Cost:</p>
           <h2>&pound; {(Math.round(withVAT12 *100) /100)}</h2>
  
           <div className="ipsum" dangerouslySetInnerHTML={{ __html: summary.length !== 0 && summary[0].summary }}></div>
          </div>
          {props.true3d12 === true && (
            <div className="totalEst2">
            <button className="btn--kitchen" data-kitchen={props.data3d12}><img className="see" src={see} alt="" ></img></button>
            <img className="threed" src={props.img3d12} alt="" />
          </div>
          )}

        </div>
      </div>
    </>
  );
}

export default Twelvemm;


// console.log(summary[0].summary)
// dangerouslySetInnerHTML={{ __html: stepDesc[8].title }}